import React from 'react';

import { key } from '@philips-emr/tws-utils';

import { getWeekDays } from '../../calendar/calendar-util';

function DatePickerAcronyms() {
  const acronyms = getWeekDays().map((weekday) => weekday[0]);

  return (
    <ul className="c-date-picker__acronyms">
      {acronyms.map((acronym) => (
        <li key={key('c-date-picker-acronym')} className="c-date-picker__item">
          {acronym}
        </li>
      ))}
    </ul>
  );
}

export default DatePickerAcronyms;
